/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react"
import { useHookstate } from "@hookstate/core";
import { IconButton } from "@mui/material";
import { Search, Clear } from "@mui/icons-material";
import { InputAdornment, OutlinedInput } from "@mui/material";
import { createSearchParams, useNavigate, useSearchParams } from "react-router-dom";
import { useInventoryState } from "../../hooks/useInventoryState";
import { useThemeState } from "../../hooks/useThemeState";
import { useTranslate } from "../../hooks/useTranslate/useTranslate";
import { useEffect } from "react";

//-------------------------------------------------------------------------------------------------------
export type ProductSearchBoxProps = {

}
export const ProductSearchBox: React.FC<ProductSearchBoxProps> = props => {
    const translate = useTranslate();
    const theme = useThemeState().get().theme;
    const inventoryState = useInventoryState();
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const keywords = searchParams.get("keywords") || '';

    // Use local state for the input value
    const searchTextState = useHookstate<string>(keywords || '');

    let inputPlaceholderText = translate('Search');
    if (inventoryState.get().catalog) {
        inputPlaceholderText += ' ' + (inventoryState.get().catalog?.Name ?? '');
    }

    const doSearch = (searchText: string) => {
        navigate({
            pathname: `/inventory/${inventoryState.get().catalog?.Id}`,
            search: createSearchParams({
                keywords: searchText,
                pageno: '1'
            }).toString()
        });
    }

    // Sync the search textbox with the keywords in the URL
    useEffect(() => {
        searchTextState.set(keywords);
    }, [searchTextState, keywords])

    return (
        <OutlinedInput
            type="text"
            placeholder={inputPlaceholderText}
            endAdornment={
                <InputAdornment position="end">
                    {(searchTextState.get().length > 0) && (
                        <IconButton aria-label="clear" onClick={async e => Promise.resolve().then(() => doSearch(''))}>
                            <Clear css={css`color:${theme.palette.siteTextPrimary};`} />
                        </IconButton>

                    )}
                    <IconButton aria-label="search">
                        <Search css={css`color:${theme.palette.siteTextPrimary};`} />
                    </IconButton>
                </InputAdornment>
            }
            size="small"
            margin="none"
            css={css`
                flex: 1 1 0;
                min-width: 300px;
                box-sizing:border-box;
                transition: all 1s;
                border-color:${theme.palette.siteTextPrimary};`}
            value={searchTextState.get()}
            onChange={async e => {
                const searchText = (e.target as HTMLInputElement).value;
                searchTextState.set(searchText);
            }}
            onKeyUp={async e => {
                const searchText = (e.target as HTMLInputElement).value;
                if (e.key === 'Enter') {
                    doSearch(searchText);
                }
            }}
            onBlur={
                async e => {
                    const searchText = (e.target as HTMLInputElement).value;
                    if (searchText !== (keywords || '')) {
                        doSearch(searchText);
                    }
                }
            }
        />
    );
}